import { Component } from '@angular/core';

@Component({
  selector: 'ui-tool-bar',
  templateUrl: './tool-bar.component.html'
})
export class ToolBarComponent {
}